import { useBreakpoints } from "@narmi/design_system";

const MQ_MAP = {
  s: "480px",
  m: "900px",
  l: "1280px",
  xl: "1440px",
};

// Mobile first only (viewport width >= breakpoint)
const getMq = (size: string) => `(min-width: ${size})`;

/**
 * Custom hook that provides breakpoint utilities for Hero components.
 * Uses predefined breakpoints and mobile-first media queries.
 */
function useHeroBreakpoints() {
  return useBreakpoints({
    s: getMq(MQ_MAP.s),
    m: getMq(MQ_MAP.m),
    l: getMq(MQ_MAP.l),
    xl: getMq(MQ_MAP.xl),
  });
}

export { useHeroBreakpoints };
